export default "__VITE_ASSET__NT1L1f3k__"